import n from "styled-components";
import { breakpoints as p } from "./atoms-v2125.js";
import { INPUT_EXPRESSIVE_HEIGHT as a, INPUT_PRODUCTIVE_HEIGHT_SMALL as e, INPUT_PRODUCTIVE_HEIGHT as s } from "./atoms-v2810.js";
import { Input as l } from "./atoms-v2777.js";
import { SkeletonRow as d } from "./atoms-v2778.js";
import { getColor as c } from "./atoms-v2815.js";
const I = n.input`
  ${l}

  ${({ $variant: o, theme: i }) => {
  var t, r;
  return o === "productive" ? (t = i == null ? void 0 : i.get("tokens.body.compact-productive")) == null ? void 0 : t.toJS() : (r = i == null ? void 0 : i.get("tokens.heading.03")) == null ? void 0 : r.toJS();
}}

  appearance: textfield;
  background-color: transparent;
  color: ${({ $colorTheme: o = "light", disabled: i, theme: t }) => c({ colorTheme: o, disabled: i, theme: t })};
  flex-grow: 1;
  height: ${({ $variant: o }) => o === "expressive" ? a : e}px;
  min-width: 0;
  padding-left: var(--padding-x);
  padding-right: var(--padding-x);
  padding-top: ${({ $variant: o }) => o === "productive" ? 18 : 5}px;
  position: relative;
  width: 100%;
  z-index: 1;

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    /* 
      Chrome autofill background hack:
      WebKit animates a yellow/blue background-color on autofill.
      This forces that animation to take ~9999s, so the autofill
      paint never visibly appears. Input keeps our custom styles.
    */
    transition:
      background-color 9999s ease-out,
      color 9999s ease-out;
  }

  @media ${p.medium} {
    ${({ $variant: o, theme: i }) => {
  var t, r;
  return o === "productive" ? (t = i == null ? void 0 : i.get("tokens.body.compact-expressive")) == null ? void 0 : t.toJS() : (r = i == null ? void 0 : i.get("tokens.heading.03")) == null ? void 0 : r.toJS();
}}
    height: ${({ $variant: o }) => o === "expressive" ? a : s}px;
  }
`, $ = n.div`
  align-items: center;
  color: ${({ $colorTheme: o = "light", $isErrored: i, theme: t }) => i ? t == null ? void 0 : t.get(`tokens.text.${o}.error`) : "inherit"};
  column-gap: 12px;
  display: flex;
  padding-right: var(--padding-x);
`, b = n(d)`
  column-gap: 1px;
  display: flex;
  height: ${({ $variant: o }) => o === "expressive" ? a : e}px;
  justify-content: end;

  @media ${p.medium} {
    height: ${({ $variant: o }) => o === "expressive" ? a : s}px;
  }
`;
export {
  $ as Icons,
  I as Input,
  b as SkeletonInput
};
